import angular from 'angular';

export default function ngThumb($window) {
  'ngInject';

  const helper = {
    support: Boolean($window.FileReader && $window.CanvasRenderingContext2D),
    isFile(item) {
      return angular.isObject(item) && item instanceof $window.File;
    },
    isImage(file) {
      const type = `|${file.type.slice(file.type.lastIndexOf('/') + 1)}|`;
      return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
    },
  };

  return {
    restrict: 'A',
    template: '<div/>',
    link(scope, element, attributes) {
      if (!helper.support) {
        return;
      }

      const params = scope.$eval(attributes.ngThumb);

      if (!helper.isFile(params.file)) {
        return;
      }

      if (!helper.isImage(params.file)) {
        return;
      }

      const reader = new FileReader();

      function onLoadFile() {
        element.css({
          width: `${params.width}px`,
          height: `${params.height}px`,
          'background-image': `url(${this.result})`,
          'background-size': 'cover',
          'background-position': 'center',
        });
      }

      reader.onload = onLoadFile;
      reader.readAsDataURL(params.file);
    },
  };
}
